/* src/pages/quickscan/page-quickscan.component.scss */
:host {
  display: block;
}
.quickscan-property {
  display: flex;
  width: 100vw;
  padding: var(--vwui-size-spacing-xs);
}
.quickscan-property .property-header {
  padding: 10px;
  vertical-align: middle;
  width: 400px;
}
.quickscan-property .property-value {
  width: 100px;
}
.weighted-score {
  padding-left: 2rem;
  font-size: x-small;
  font-weight: 500;
  display: inline;
}
.quickscan-theme {
  margin-bottom: var(--vwui-size-spacing-lg);
}
.quickscan-subject {
  font-weight: 500;
}
.quickscan-col--nr {
  width: 2rem;
}
.quickscan-col--question {
  white-space: normal;
}
.quickscan-col--maxscore {
  width: 5rem;
  text-align: center;
}
.quickscan-col--maxscore-total {
  font-weight: bold;
}
.quickscan-col--options {
  width: 1px;
  white-space: nowrap;
}
/*# sourceMappingURL=page-quickscan.component-WIT2RS3I.css.map */
